(function () {
  "use strict";

  /* Libelles : snippets/i18n-js.liquid (cles agenda.*), lus au moment de l'appel. Spec 07.
     Ecrits en textContent ou en attribut, jamais en innerHTML (assets/i18n.js decode
     les entites). Les messages renvoyes par l'API (data.error) restent tels quels. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  function text(el, value) {
    if (el) el.textContent = value || "";
  }

  function show(el, visible) {
    if (el) el.hidden = !visible;
  }

  async function requestJson(url, options) {
    var res = await fetch(url, Object.assign({
      headers: { Accept: "application/json" },
    }, options || {}));
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || data.ok === false) {
      throw new Error(data.error || i18n("agenda.errors.generic"));
    }
    return data;
  }

  function payload(form) {
    var data = new FormData(form);
    var out = {};
    data.forEach(function (value, key) {
      out[key] = String(value || "").trim();
    });
    return out;
  }

  function init(root) {
    if (!root || root.dataset.ready === "1") return;
    root.dataset.ready = "1";

    var form = root.querySelector("[data-consultation-form]");
    var calendar = root.querySelector("[data-consultation-calendar]");
    var calendarPanel = calendar ? calendar.closest(".edp__calendar-panel") : null;
    var slotInput = root.querySelector("[data-consultation-slot-value]");
    var selection = root.querySelector("[data-consultation-selection]");
    var submit = root.querySelector("[data-consultation-submit]");
    var loading = root.querySelector("[data-consultation-loading]");
    var success = root.querySelector("[data-consultation-success]");
    var error = root.querySelector("[data-consultation-error]");
    var slotsUrl = root.getAttribute("data-slots-url");
    var bookUrl = root.getAttribute("data-book-url");
    var currentSlots = [];

    var intlLocale = window.FOG_I18N.intl("fr-FR");
    var dayFormatter = new Intl.DateTimeFormat(intlLocale, {
      weekday: "long",
      day: "2-digit",
      month: "long",
      timeZone: "Europe/Paris",
    });
    var timeFormatter = new Intl.DateTimeFormat(intlLocale, {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Europe/Paris",
    });

    function setError(message) {
      text(error, message);
      show(error, !!message);
    }

    function setBusy(isBusy) {
      if (submit) submit.disabled = isBusy || !slotInput || !slotInput.value;
      if (calendar) {
        calendar.querySelectorAll("[data-slot-start]").forEach(function (button) {
          // Un creneau indisponible reste desactive quel que soit l etat du formulaire.
          if (button.getAttribute("data-unavailable") === "1") return;
          button.disabled = isBusy;
        });
      }
    }

    function dayKey(slot) {
      return slot.start_at.slice(0, 10);
    }

    // L API renvoie desormais tous les creneaux avec un drapeau de disponibilite.
    // Un slot sans drapeau (ancienne version de l API) est considere disponible.
    function isAvailable(slot) {
      return slot.available !== false;
    }

    function labelForSlot(slot) {
      var d = new Date(slot.start_at);
      return i18n("agenda.calendar.slot_at", { day: dayFormatter.format(d), time: timeFormatter.format(d) });
    }

    function setSelected(startAt) {
      if (slotInput) slotInput.value = startAt || "";
      var selectedSlot = currentSlots.filter(function (slot) {
        return slot.start_at === startAt;
      })[0];
      if (selection) {
        if (selectedSlot) {
          text(selection, i18n("agenda.calendar.selected", { slot: labelForSlot(selectedSlot) }));
          show(selection, true);
        } else {
          text(selection, "");
          show(selection, false);
        }
      }
      if (calendar) {
        calendar.querySelectorAll("[data-slot-start]").forEach(function (button) {
          var active = button.getAttribute("data-slot-start") === startAt;
          button.classList.toggle("is-selected", active);
          button.setAttribute("aria-checked", active ? "true" : "false");
        });
      }
      if (submit) submit.disabled = !startAt;
    }

    /**
     * Indice de scroll du calendrier : ajoute .has-calendar-scroll sur le panneau
     * (fondu + libellé "Faites défiler...") uniquement si la grille déborde
     * réellement et n'est pas déjà scrollée jusqu'en bas.
     */
    function updateCalendarScrollHint() {
      if (!calendar || !calendarPanel) return;
      var hasOverflow = calendar.scrollHeight > calendar.clientHeight + 2;
      var nearBottom = calendar.scrollTop + calendar.clientHeight >= calendar.scrollHeight - 4;
      calendarPanel.classList.toggle("has-calendar-scroll", hasOverflow && !nearBottom);
    }

    function renderSlots(slots) {
      currentSlots = slots || [];
      if (slotInput) slotInput.value = "";
      if (submit) submit.disabled = true;
      if (!calendar) return;
      calendar.innerHTML = "";

      if (!currentSlots.length) {
        var empty = document.createElement("div");
        empty.className = "edp__calendar-empty";
        empty.textContent = i18n("agenda.calendar.empty");
        calendar.appendChild(empty);
        show(selection, false);
        updateCalendarScrollHint();
        return;
      }

      // Tous les creneaux de la periode sont pris ou bloques : on affiche quand meme
      // le calendrier grise, precede d une explication.
      var hasAvailable = currentSlots.some(isAvailable);
      if (!hasAvailable) {
        var none = document.createElement("div");
        none.className = "edp__calendar-empty";
        none.textContent = i18n("agenda.calendar.all_booked");
        calendar.appendChild(none);
      }

      var byDay = {};
      currentSlots.forEach(function (slot) {
        var key = dayKey(slot);
        if (!byDay[key]) byDay[key] = [];
        byDay[key].push(slot);
      });

      Object.keys(byDay).forEach(function (key) {
        var daySlots = byDay[key];
        var firstDate = new Date(daySlots[0].start_at);
        var card = document.createElement("section");
        card.className = "edp__calendar-day";

        var heading = document.createElement("h4");
        heading.className = "edp__calendar-day-title";
        heading.textContent = dayFormatter.format(firstDate);
        card.appendChild(heading);

        var times = document.createElement("div");
        times.className = "edp__calendar-times";
        daySlots.forEach(function (slot) {
          var available = isAvailable(slot);
          var button = document.createElement("button");
          button.type = "button";
          button.className = "edp__calendar-slot";
          button.setAttribute("role", "radio");
          button.setAttribute("aria-checked", "false");
          button.setAttribute("data-slot-start", slot.start_at);
          button.textContent = timeFormatter.format(new Date(slot.start_at));
          if (available) {
            button.addEventListener("click", function () {
              setSelected(slot.start_at);
            });
          } else {
            button.classList.add("is-unavailable");
            button.setAttribute("data-unavailable", "1");
            button.setAttribute("aria-disabled", "true");
            button.setAttribute("aria-label", i18n("agenda.calendar.slot_unavailable", { time: button.textContent }));
            button.disabled = true;
          }
          times.appendChild(button);
        });

        card.appendChild(times);
        calendar.appendChild(card);
      });

      // Laisse le layout se stabiliser avant de mesurer le debordement reel.
      requestAnimationFrame(updateCalendarScrollHint);
    }

    async function loadSlots() {
      show(loading, true);
      setError("");
      try {
        var data = await requestJson(slotsUrl);
        renderSlots(Array.isArray(data.slots) ? data.slots : []);
      } catch (err) {
        renderSlots([]);
        setError(err.message || i18n("agenda.errors.load"));
      } finally {
        show(loading, false);
      }
    }

    if (calendar) {
      calendar.addEventListener("scroll", updateCalendarScrollHint);
      window.addEventListener("resize", updateCalendarScrollHint);
    }

    if (form) {
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        show(success, false);
        setError("");
        if (!slotInput || !slotInput.value) {
          setError(i18n("agenda.errors.select_slot"));
          return;
        }
        setBusy(true);
        try {
          await requestJson(bookUrl, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload(form)),
          });
          form.reset();
          renderSlots([]);
          show(success, true);
          if (window.FOG_ADS) window.FOG_ADS.trackBooking();
          await loadSlots();
        } catch (err) {
          setError(err.message || i18n("agenda.errors.book"));
          await loadSlots();
        } finally {
          setBusy(false);
        }
      });
    }

    loadSlots();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-consultation-booking]").forEach(init);
  });
})();
